import { render, staticRenderFns } from "./create-personal-new.vue?vue&type=template&id=d0e6bcc6&scoped=true&"
import script from "./create-personal-new.vue?vue&type=script&lang=js&"
export * from "./create-personal-new.vue?vue&type=script&lang=js&"
import style0 from "./create-personal-new.vue?vue&type=style&index=0&id=d0e6bcc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e6bcc6",
  null
  
)

export default component.exports